import React, { useState, useEffect } from 'react';
import './HearAboutUs.css';
import { fetchQuote, createActivityQuoteDB } from '../API/Model';
import { Link } from 'react-router-dom';

function HearAboutUs(props) {

    const radioOptions = ["Facebook", "Instagram", "Mail", "Newsletter", "Nextdoor", "Youtube", "Referral", "Other"];

    const handleChange = (event) => {
        props.set_how_did_you_hear(event.target.value);
    };
    function onButtonClick() {
        createActivityQuoteDB('HearAboutUs', 'NAV', 'Continue button');
        if (props.how_did_you_hear === "Referral") {
            props.setDisplayReferral(true);
        } else {
            props.setDisplayReferral(false);
        }
        props.updateQuoteInformation();
        props.setDisplayHearAboutUs(false);
    }
    function onBackButtonClick() {
        createActivityQuoteDB('HearAboutUs', 'NAV', 'Back button');
    }

    return (
        <div className="hearaboutus_wrapper">

            <div className="wrapper_p20">

                <div className="contentBox_p20">
                    <div className="p20_c1_r0 home_value">
                        <p className="label_p20 no_wrap mx-auto">While we calculate your estimate, how did you hear about us?</p>
                    </div>
                    <div className="p20_c1_r1">
                        {radioOptions.map((option, idx) => (
                            <>
                                <div className="form-check mb-2" key={idx}>
                                    <label className="form-check-label radio-button-label" style={{ display: 'flex', alignItems: 'center' }}>
                                        <input
                                            className="form-check-input"
                                            style={{ marginBottom: '0.125em' }}
                                            type="radio"
                                            name="how"
                                            value={option}
                                            checked={props.how_did_you_hear === option}
                                            onChange={handleChange}
                                        />

                                        {option}

                                        {option === "Other" && (
                                            <>
                                                <input
                                                    className="inp_p20_1 ml-2 px-2"
                                                    type="text"
                                                    value={props.how_did_you_hear_other}
                                                    onChange={(e) => props.set_how_did_you_hear_other(e.target.value)}
                                                />
                                            </>
                                        )}
                                    </label>

                                    
                                </div>
                            </>
                        ))}
                    </div>
                    <div className="footer">
                        <div className="btn_p20_wrapper">
                            <Link to={{
                                pathname: "/PropertyInfo",
                            }}>
                                <p className="btn_p20_2" onClick={onBackButtonClick}>&lt;<span>Back</span></p>
                            </Link>
                            <button className="btn_p20" onClick={onButtonClick}>Continue</button>
                        </div>
                        <b>
                            <p className="footer_p20_1"> Questions? (800) 648-1794</p>
                            <p className="footer_p20_1_5"> <a href="mailto: service@mutual-assurance.com">service@mutual-assurance.com</a></p>
                            <p className="footer_p20_2">(Monday to Friday 8am – 4:30pm)</p>
                        </b>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HearAboutUs


